import { Icon } from '@fluentui/react';
import React from 'react'

const TroubleShootingTab = (props) => {

    return (
      <>
      <div className={props.contentClass}>
          <Icon className="icon">{props.icon}</Icon>
          <h4
          className={`textContent-study-list ${
            props.active ? "highlight-tab" : ""
          }`}
        >
          {props.title}
        </h4>
        {props.active && <div className="hide-border-bottom-border-tabs"></div>}
      </div>
      </>
    );
  };

export default TroubleShootingTab